import axios from "axios";
import { httpClient } from "@/app/shared/shared-services/httpClient";
import { environment } from "@/environment";

const URL = environment.volunteerApiBaseUrl;

function getEntityName(entityEndpoint) {
  return `${entityEndpoint.replace(
    "/",
    "-"
  )}-${new Date().toLocaleDateString()}`;
}

async function exportEntity(entityEndpoint, filename = null) {
  const url = `${URL}${entityEndpoint}`;
  const response = await httpClient.get(url, { responseType: "arraybuffer" });

  let fileURL = window.URL.createObjectURL(new Blob([response.data]));
  let fileLink = document.createElement("a");
  fileLink.href = fileURL;

  fileLink.setAttribute(
    "download",
    `${filename ? filename : getEntityName(entityEndpoint)}.csv`
  );
  document.body.appendChild(fileLink);
  fileLink.click();

  window.URL.revokeObjectURL(fileURL);
  fileLink.remove();
}

export default {
  async fetchVolunteers(query) {
    const url = `${URL}v1/volunteers${query}`;
    return (await httpClient.get(url)).data;
  },
  async removeVolunteer(volunteerId) {
    const url = `${URL}v1/volunteers/${volunteerId}`;
    return await httpClient.delete(url);
  },
  async resetVolunteerPassword(volunteerId) {
    const url = `${URL}v1/volunteers/${volunteerId}/reset-password`;
    return await httpClient.post(url);
  },
  async toggleStatus(volunteerId, payload) {
    const url = `${URL}v1/volunteers/${volunteerId}/toggle-status`;
    return await httpClient.post(url, payload);
  },
  async exportVolunteers() {
    return await exportEntity("v1/volunteers/export");
  },
  async exportTasksVolunteers() {
    return await exportEntity("v1/cms/volunteers/export", "TasksVolunteers");
  },
  async exportAppliedVolunteers(query) {
    return await exportEntity(`v1/cms/tasks/volunteers/applied/export${query}`);
  },
  async sendNotifications({ payload, query }) {
    const url = `${URL}v1/cms/notifications${query}`;
    return await httpClient.post(url, payload);
  },
  async fetchNotificationBatches(query) {
    const url = `${URL}v1/cms/notifications/batches${query}`;
    return (await httpClient.get(url)).data;
  },
  async fetchNotificationBatchVolunteers(batchId, query) {
    const url = `${URL}v1/cms/notifications/batches/${batchId}/volunteers${query}`;
    return (await httpClient.get(url)).data;
  },
  async uploadVolunteersImagesFile(file, onProgress) {
    // Step 1: get a presigned PUT URL from the backend
    const { data: { uploadUrl, key } } = await httpClient.post(
      `${URL}v1/cms/volunteers/upload/presigned-url`,
      { filename: file.name }
    );

    // Step 2: PUT the file directly to R2 using a plain axios instance
    // (httpClient carries auth headers that break the R2 CORS preflight)
    await axios.put(uploadUrl, file, {
      headers: { 'Content-Type': 'application/zip' },
      onUploadProgress: onProgress,
    });

    // Step 3: tell the backend to start processing
    return await httpClient.post(`${URL}v1/cms/volunteers/upload/process`, { key });
  },

  async getUploadJobStatus(jobId) {
    const url = `${URL}v1/cms/volunteers/upload/status/${jobId}`;
    return (await httpClient.get(url)).data;
  },
};
